import { HSComponent } from "./component.js";
import * as Logger from "./logger.js";
import styles from "./time-picker.css";
import template from "./time-picker.html";
import { HSToolbarButton } from "./toolbar-button.js";
import { UserSession } from './session.js';

class HSTimePicker extends HSComponent {
    constructor() {
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
    }

    init({ timeScopes = [] } = {}) {
        const container = this.shadowRoot.querySelector('.container');
        if (container && timeScopes.length > 0) {
            const supportedScope = [ 'day', 'week', 'month', 'quarter', 'all' ];
            for (const scope of supportedScope) {
                if (timeScopes.includes(scope)) {
                    const button = document.createElement('hs-toolbar-button');
                    button.id = scope;
                    button.setAttribute('title', scope.charAt(0).toUpperCase() + scope.slice(1));
                    button.setAttribute('action', `hs-${scope}-view`);
                    container.appendChild(button);
                    this.onEvent('hs-'+scope+'-view', (opts) => this.onSelect(opts.button));
                }
            }
        }

        const timeScope = timeScopes.includes(UserSession.get("timeScope")) ? UserSession.get("timeScope") : timeScopes.slice(-1)[0];
        const button = this.shadowRoot.getElementById(timeScope);
        if (button) {
            this.onSelect(button);
        }
    }

    onSelect(selectedButton) {
        const buttons = this.findChildren({ predicate: child => child instanceof HSToolbarButton }); //  && child.config.tabGroup == tabGroup });
        buttons.forEach(button => {
            button.setSelected(false);
        });
        selectedButton.setSelected(true);
    }
}
customElements.define("hs-time-picker", HSTimePicker);
